import styled from 'styled-components';
import Link from '../../atoms/Link/Link';
import query from '../../../const/mediaQueries';
import { fontWeights, opacities } from '../../../defaultTheme';
import Small from '../../typography/Small';
import Button from '../../atoms/Button/Button';
const FooterWrapper = styled.footer `
  background-color: ${({ theme }) => theme.footer.background};
  color: ${({ theme }) => theme.footer.text};
  padding: 16px 0px 16px 0px;
  text-align: center;
  display: flex;
  flex-direction: column;
`;
const LinkList = styled.ul `
  width: 100%;
  padding: 0;
  margin-bottom: 0px;
  margin-top: 0px;
  @media ${query.greaterThanMedium} {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
`;
const LinkItem = styled.li `
  display: block;
  padding-bottom: 8px;
  @media ${query.greaterThanMedium} {
    display: inline;
    padding-bottom: 0px;
    &:not(:last-of-type) {
      margin-right: 24px;
    }
  }
`;
const InfoWrapper = styled(Small) `
  line-height: 20px;
  padding-left: 32px;
  padding-right: 32px;
  max-width: 1024px;
  align-self: center;
`;
const IconButton = styled.button `
  width: 36px;
  background: transparent;
  border: none;
  cursor: pointer;
  &:focus {
    outline: ${(p) => p.theme.focus || '-webkit-focus-ring-color'} auto 5px;
  }
  @media ${query.lessThanMedium} {
    padding: 0;
  }
`;
const Anchor = styled(Link) `
  color: ${({ theme }) => theme.footer.link};
  font-weight: ${fontWeights.bold};

  &:visited {
    color: ${({ theme }) => theme.footer.link};
  }
`;
const Divider = styled.div `
  height: 1px;
  background-color: ${opacities.rgbaLight15};
  margin: 16px 32px 16px 32px;

  @media ${query.lessThanMedium} {
    margin: 16px 0px;
  }
`;
const LinkItemButton = styled(Button) `
  display: inline-block;
  color: ${({ theme }) => theme.footer.link};
  margin: 0;
  padding: 0;
`;
export { FooterWrapper, LinkList, LinkItem, IconButton, InfoWrapper, Anchor, Divider, LinkItemButton };
//# sourceMappingURL=subcomponents.js.map